import { Box, Typography, Alert } from '@mui/material';
import { FormattedMessage } from 'react-intl';
import PhotoGrid from './visit-detail-photo-grid';
import DeleteConfirmDialog from './visit-detail-photo-delete-dialog';
import PhotoViewDialog from './visit-detail-photo-view-dialog';
import { Photo } from '@features/visits/api';
import { useVisitDetailPhotoGallery } from './visit-detail-photo-gallery.hooks';

type VisitDetailPhotoGalleryProps = {
  photos: Photo[];
  onDelete: (photoId: string, photoUrl: string) => Promise<void>;
};

const VisitDetailPhotoGallery = ({ photos, onDelete }: VisitDetailPhotoGalleryProps) => {
  const {
    selectedPhoto,
    deleteConfirmPhoto,
    isDeleting,
    error,
    handleDelete,
    handlePhotoClick,
    handleClosePhotoView,
    handleDeleteClick,
    handleCancelDelete,
    clearError,
  } = useVisitDetailPhotoGallery(onDelete);

  if (photos.length === 0) {
    return (
      <Box py={2}>
        <Typography variant="body2" color="text.secondary" textAlign="center">
          <FormattedMessage
            id="hairstyle.photo.no.photos"
            defaultMessage="Zatím nejsou přidány žádné fotografie"
          />
        </Typography>
      </Box>
    );
  }

  return (
    <>
      {error && (
        <Alert severity="error" onClose={clearError} sx={{ mb: 2 }}>
          {error}
        </Alert>
      )}

      <PhotoGrid
        photos={photos}
        onPhotoClick={handlePhotoClick}
        onDeleteClick={handleDeleteClick}
      />

      <PhotoViewDialog photo={selectedPhoto} onClose={handleClosePhotoView} />

      <DeleteConfirmDialog
        open={!!deleteConfirmPhoto}
        isDeleting={isDeleting}
        onConfirm={handleDelete}
        onCancel={handleCancelDelete}
      />
    </>
  );
};

export default VisitDetailPhotoGallery;
